import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useContext, useState } from "react";
import { toast } from 'react-toastify';

import logo from "../../public/images/logo/elms-logo-black2.png";
import logo1 from "../../public/images/logo/elms-logo-black2.png";

import Nav from "./Nav";
import HrNav from "./HrNav";
import { useAppContext } from "@/context/Context";
import { UserContext } from "@/context/UserContext";
import User from "./Offcanvas/User";

const profileRoutes = {
  student: "/student/student-profile",
  instructor: "/instructor/instructor-profile",
  hr: "/hr-admin/hr-profile",
  admin: "/admins/admin-profile"
};

const MobileMenu = () => {
  const { mobile, setMobile } = useAppContext();
  const router = useRouter();
  const { user, logoutUser } = useContext(UserContext);
  const [showUserMenu, setShowUserMenu] = useState(false);

  const logout = async (e) => {
    e.preventDefault();

    await logoutUser();

    let redirectUrl = '/login';
    if (user?.role === 'hr') {
      redirectUrl = '/login?role=hr';
    } else if (user?.role === 'instructor') {
      redirectUrl = '/login?role=instructor';
    } else if (user?.role === 'admin') {
      redirectUrl = '/login?role=admin';
    }

    setMobile(!mobile);
    router.push(redirectUrl);
  };

  const handleCopyReferralCode = () => {
    if (!user?.referralCode) return;

    navigator.clipboard.writeText(user.referralCode).then(() => {
      toast.success('Referral code copied!');
    }).catch(err => {
      console.error('Copy failed:', err);
    });
  };

  const handleCopyReferralLink = () => {
    if (!user?.referralCode) return;

    const referralUrl = `${window.location.origin}?ref=${user.referralCode}`;
    navigator.clipboard.writeText(referralUrl).then(() => {
      toast.success('Referral link copied!');
    }).catch(err => {
      console.error('Copy failed:', err);
    });
  };

  const handleShareReferral = () => {
    if (!user?.referralCode) return;

    const referralUrl = `${window.location.origin}?ref=${user.referralCode}`;
    const shareText = `Hey! 👋

I've been using this awesome platform and thought you might like it too!

Sign up with my referral code: ${user.referralCode}

Link: ${referralUrl}`;

    if (navigator.share) {
      navigator.share({
        title: 'Join with my referral code',
        text: shareText,
      }).catch(err => console.log('Share cancelled'));
    } else {
      handleCopyReferralLink();
    }
  };

  const role = user?.role || "student";
  const profileRoute = profileRoutes[role] || "/student/student-profile";

  return (
    <>
      <div className={`popup-mobile-menu ${mobile ? "" : "active"}`}>
        <div className="inner-wrapper">
          <div className="inner-top">
            <div className="content">
              <div className="logo">
                <Link href="/">
                  <Image
                    src={logo}
                    width={137}
                    height={45}
                    alt="Education Logo Images"
                  />
                </Link>
              </div>
              <div className="rbt-btn-close">
                <button
                  className="close-button rbt-round-btn"
                  onClick={() => setMobile(!mobile)}
                  aria-label="Close menu"
                  title="Close menu"
                >
                  <i className="feather-x"></i>
                </button>
              </div>
            </div>

            {user && (
              <div className="rbt-admin-profile" style={{ padding: '15px 0', borderBottom: '1px solid #e5e7eb' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div className="admin-thumbnail">
                    <Image
                      src={user.img || "/images/team/avatar.jpg"}
                      width={50}
                      height={50}
                      alt="User"
                      style={{ borderRadius: '50%' }}
                    />
                  </div>
                  <div className="admin-info">
                    <span className="name" style={{ display: 'block', fontWeight: '600', fontSize: '16px' }}>
                      {user.userName && user.userName.charAt(0).toUpperCase() + user.userName.slice(1)}
                    </span>
                    <Link
                      className="rbt-btn-link color-primary"
                      href={profileRoute}
                      onClick={() => setMobile(!mobile)}
                      style={{ fontSize: '13px' }}
                    >
                      View Profile
                    </Link>
                  </div>
                </div>
              </div>
            )}

            <ul className="navbar-top-left rbt-information-list justify-content-start" style={{ marginTop: '15px' }}>
              <li>
                <a href="tel:+919562461503">
                  <i className="feather-phone"></i>+91 9562461503
                </a>
              </li>
              <li>
                <a href="mailto:info@emdeondigital.com">
                  <i className="feather-mail"></i>info@emdeondigital.com
                </a>
              </li>
            </ul>
          </div>

          {role === 'hr' ? <HrNav isMobile={true} /> : <Nav isMobile={true} />}

          {user && (
            <div style={{ padding: '20px 0', borderTop: '1px solid #e5e7eb', borderBottom: '1px solid #e5e7eb' }}>
              <button
                onClick={() => setShowUserMenu(!showUserMenu)}
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '10px 0',
                  border: 'none',
                  background: 'transparent',
                  cursor: 'pointer',
                  fontSize: '15px',
                  fontWeight: '700',
                  color: '#2563eb'
                }}
              >
                <span className="name">My Account</span>
                <i
                  className={`feather-chevron-${showUserMenu ? 'up' : 'down'}`}
                  style={{
                    fontSize: '14px'
                  }}
                ></i>
              </button>

              {showUserMenu && (
                <div onClick={() => setMobile(!mobile)}>
                  <User showProfile={false} showLogout={false} isMobile={true} />
                </div>
              )}
            </div>
          )}

          {user?.referralCode && (
            <div style={{ padding: '20px 0', borderBottom: '1px solid #e5e7eb' }}>
              <span className="rbt-short-title d-block" style={{ marginBottom: '15px', fontWeight: '600' }}>
                🎁 Refer & Earn
              </span>

              <div style={{
                padding: '12px',
                backgroundColor: '#f0f9ff',
                borderRadius: '8px',
                marginBottom: '15px'
              }}>
                <strong style={{
                  display: 'block',
                  marginBottom: '6px',
                  color: '#1f2937',
                  fontSize: '11px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px'
                }}>
                  Your Referral Code
                </strong>
                <span style={{
                  fontSize: '16px',
                  color: '#2563eb',
                  fontWeight: 'bold',
                  letterSpacing: '1.5px',
                  fontFamily: 'monospace'
                }}>
                  {user.referralCode}
                </span>
              </div>

              <ul className="user-list-wrapper" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                <li style={{ marginBottom: '8px' }}>
                  <button
                    onClick={handleCopyReferralCode}
                    style={{
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      padding: '10px 0',
                      border: 'none',
                      background: 'transparent',
                      textAlign: 'left',
                      cursor: 'pointer',
                      fontSize: '14px',
                      color: '#374151'
                    }}
                  >
                    <i className="feather-copy" style={{ color: '#2563eb' }}></i>
                    <span>Copy Referral Code</span>
                  </button>
                </li>
                <li style={{ marginBottom: '8px' }}>
                  <button
                    onClick={handleCopyReferralLink}
                    style={{
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      padding: '10px 0',
                      border: 'none',
                      background: 'transparent',
                      textAlign: 'left',
                      cursor: 'pointer',
                      fontSize: '14px',
                      color: '#374151'
                    }}
                  >
                    <i className="feather-link" style={{ color: '#2563eb' }}></i>
                    <span>Copy Referral Link</span>
                  </button>
                </li>
                <li>
                  <button
                    onClick={handleShareReferral}
                    style={{
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      padding: '10px 0',
                      border: 'none',
                      background: 'transparent',
                      textAlign: 'left',
                      cursor: 'pointer',
                      fontSize: '14px',
                      color: '#374151'
                    }}
                  >
                    <i className="feather-share-2" style={{ color: '#2563eb' }}></i>
                    <span>Share on Social Media</span>
                  </button>
                </li>
              </ul>
            </div>
          )}

          <div className="mobile-menu-bottom">
            {user && (
              <div style={{ marginBottom: '20px' }}>
                <button
                  onClick={logout}
                  style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '10px',
                    padding: '12px',
                    border: '1px solid #e5e7eb',
                    background: '#fff',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    color: '#dc2626',
                    fontWeight: '500'
                  }}
                >
                  <i className="feather-log-out"></i>
                  <span>Logout</span>
                </button>
              </div>
            )}

            {!user && (
              <div className="rbt-btn-wrapper mb--20">
                <Link
                  className="rbt-btn btn-border-gradient radius-round btn-sm hover-transform-none w-100 justify-content-center text-center"
                  href="/login"
                  onClick={() => setMobile(!mobile)}
                >
                  <span>Login / Register</span>
                </Link>
              </div>
            )}

            <div className="social-share-wrapper">
              <span className="rbt-short-title d-block">Find With Us</span>
              <ul className="social-icon social-default transparent-with-border justify-content-start mt--20">
                <li>
                  <Link href="https://www.facebook.com/">
                    <i className="feather-facebook"></i>
                  </Link>
                </li>
                <li>
                  <Link href="https://www.twitter.com">
                    <i className="feather-twitter"></i>
                  </Link>
                </li>
                <li>
                  <Link href="https://www.instagram.com/">
                    <i className="feather-instagram"></i>
                  </Link>
                </li>
                <li>
                  <Link href="https://www.linkdin.com/">
                    <i className="feather-linkedin"></i>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileMenu;